export default __webpack_public_path__ + "static/media/20at60.85480855.jpg";